import { render, staticRenderFns } from "./ReadMode.vue?vue&type=template&id=3654d5d1&scoped=true&"
import script from "./ReadMode.vue?vue&type=script&lang=js&"
export * from "./ReadMode.vue?vue&type=script&lang=js&"
import style0 from "./ReadMode.vue?vue&type=style&index=0&id=3654d5d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3654d5d1",
  null
  
)

export default component.exports